// Config
import localeConfig, {companyLangToLocale} from "@/config/localeConfig"

// Utils
import {getCookie} from "@/utils/utils"

type Locale = "fr_FR" | "en_US" | "nl_NL" | "fr_FR_CSE"

const useLocale = (): Locale => {
    // Get the company language
    const companyLang = getCookie("companyLang") || ""
    
    // Use the company language if we have it otherwise use the lang from the document
    const htmlElement = document.querySelector("html") as HTMLElement
    const lang = companyLangToLocale.get(companyLang) || htmlElement.getAttribute("lang") || "fr_FR";

    // Map the locale to the correct format
    return localeConfig[lang] as Locale;
}

export default useLocale